/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import "./src/styles/main.css"

import { rememberUtmParameters } from "./src/helpers/utm"

export const onRouteUpdate = ({ location }) => {
  rememberUtmParameters(location.search)
}
